import _ from 'lodash';

import { ErroredModel } from '../types/ErroredModel';

export type UuidObject = {
  uuid: string
}

export const uuidFinder = function <Type extends UuidObject>(collection: Type[], uuid: string | undefined | null): Type | null {
  return (_.find(collection, { uuid }) || null) as Type | null;
};


export type ErrorObject = {
  error?: boolean,
  helperText?: string,
}

export const errorPopulator = function <Type extends ErroredModel>(object: Type | null, fieldName: string): ErrorObject {
  const invalidationMessage = _.get(object?.errors, `${fieldName}[0]`, null);
  if (!invalidationMessage) return {};

  return {
    error: !!invalidationMessage,
    helperText: invalidationMessage && `${_.capitalize(_.startCase(fieldName))} ${invalidationMessage}`,
  };
};

export const EMAIL_REGEX = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*/;

// Phone for Canada and US only (10 digits)
// Reference: ApplicationRecord::PHONE_NUMBER_REGEX
export const PHONE_NUMBER_REGEX = /^\+?\(?\d{1,4}\)?[-\s./\d]+$/i;
